import styled from "styled-components";
import { breakpoints } from "iparque-components";
import Footer from "../Footer";

export const BackgroundContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
`;

export const StyledFooter = styled(Footer)`
  padding-top: 170px;

  @media (max-width: ${breakpoints.lg}) {
    padding-top: 190px;
    padding-bottom: 200px;
  }

  @media (max-width: ${breakpoints.md}) {
    padding-top: 220px;
  }
`;
